"use client";

import { COOKIE_KEY_FONT_STYLE } from "../lib/cookies/cookieFontStyle.cookie";
import { COOKIE_KEY_LETTER_SPACING } from "../lib/cookies/cookieLetterSpacing.cookie";
import { COOKIE_KEY_PREFERRED_THEME } from "../lib/cookies/cookieTheme.cookie";
import { COOKIE_KEY_WORD_SPACING } from "../lib/cookies/cookieWordSpacing.cookie";
import { genericBooleanSchema } from "../lib/types/schema/genericBooleanSchema";
import type { LSFontFamily } from "../lib/types/schema/localStorage/lsFontFamilySchema";
import { lsFontFamilySchema } from "../lib/types/schema/localStorage/lsFontFamilySchema";
import type { LSTheme } from "../lib/types/schema/localStorage/lsThemeSchema";
import { lsThemeSchema } from "../lib/types/schema/localStorage/lsThemeSchema";
import { getValidatedCookie } from "../lib/utils/cookies";

export const useAccessibility = () => {
  const theme =
    getValidatedCookie<LSTheme>(
      COOKIE_KEY_PREFERRED_THEME,
      lsThemeSchema,
      true,
    ) ?? "match";
  const fontStyle =
    getValidatedCookie<LSFontFamily>(
      COOKIE_KEY_FONT_STYLE,
      lsFontFamilySchema,
      true,
    ) ?? "normal";
  const wordSpacing =
    getValidatedCookie<Boolean>(
      COOKIE_KEY_WORD_SPACING,
      genericBooleanSchema,
      true,
    ) ?? false;
  const letterSpacing =
    getValidatedCookie<Boolean>(
      COOKIE_KEY_LETTER_SPACING,
      genericBooleanSchema,
      true,
    ) ?? false;

  return {
    preferredTheme: theme,
    hlwFontStyle: fontStyle,
    hlwLetterSpacing: letterSpacing ? "expanded" : "default",
    hlwWordSpacing: wordSpacing ? "expanded" : "default",
  };
};
